import { merchantInstance } from "@/axios-path.js";

export default {
    namespaced: true,
    state: {
        loading: false,
        error: null,
        list: [],
        count: 0,
        page: 1,
        page_size: 20,
    },
    mutations: {
        setLoading(state, v) {
            state.loading = !!v;
        },
        setError(state, e) {
            state.error = e || null;
        },
        setList(state, rows) {
            state.list = Array.isArray(rows) ? rows : [];
        },
        setMeta(state, { count, page, page_size }) {
            state.count = Number(count || 0);
            state.page = Number(page || 1);
            state.page_size = Number(page_size || 20);
        },
        updateItemInList(state, item) {
            if (!item || !item.id) return;
            const idx = state.list.findIndex((r) => Number(r.id) === Number(item.id));
            if (idx === -1) state.list.unshift(item);
            else state.list.splice(idx, 1, item);
        },
    },
    actions: {
        async fetch({ commit }, params = {}) {
            commit("setLoading", true);
            commit("setError", null);
            try {
                const query = {
                    page: params.page || 1,
                    page_size: params.page_size || 20,
                    batch_id: params.batch_id,
                    status: params.status,
                    record_status: params.record_status,
                    province_id: params.province_id,
                    district_id: params.district_id,
                    merchant_id: params.merchant_id,
                    store_id: params.store_id,
                };
                const res = await merchantInstance.get(
                    "/api/v1/merChant/financial/transfer-items",
                    { params: query, headers: { "X-App-Client": "weserve_backoffice" } }
                );

                let payload = null;
                if (res && res.msg && res.data) payload = res;
                else if (res && res.data) payload = { ...res, msg: true };
                else if (Array.isArray(res)) payload = { msg: true, data: res, count: res.length, page: query.page, page_size: query.page_size };
                else payload = res;

                const rows = (payload && payload.data) || [];
                commit("setList", rows);
                commit("setMeta", {
                    count: payload && payload.count,
                    page: payload && payload.page,
                    page_size: payload && payload.page_size,
                });
                return rows;
            } catch (e) {
                commit("setError", e);
                commit("setList", []);
                commit("setMeta", { count: 0, page: 1, page_size: 20 });
                return [];
            } finally {
                commit("setLoading", false);
            }
        },

        async updateBank({ commit }, payload = {}) {
            commit("setError", null);
            try {
                const body = {
                    item_id: payload.item_id,
                    bank_account_number: payload.bank_account_number,
                    bank_account_name: payload.bank_account_name,
                    bank_code: payload.bank_code,
                    store_bank_id: payload.store_bank_id,
                    store_bank_bank_id: payload.store_bank_bank_id,
                };
                const res = await merchantInstance.post(
                    "/api/v1/merChant/financial/transfer-item/bank",
                    body,
                    { headers: { "X-App-Client": "weserve_backoffice" } }
                );

                const data = res && res.data ? res.data : res;
                const item = data && data.data ? data.data : data;
                if (item && item.id) commit("updateItemInList", item);
                return item;
            } catch (e) {
                commit("setError", e);
                return null;
            }
        },

        async retryItem({ commit }, payload = {}) {
            commit("setError", null);
            try {
                const body = {
                    item_id: payload.item_id,
                    run_now: payload.run_now !== undefined ? payload.run_now : true,
                    ignore_config: payload.ignore_config !== undefined ? payload.ignore_config : true,
                    ignore_merchant_balance: payload.ignore_merchant_balance !== undefined ? payload.ignore_merchant_balance : true,
                };
                const res = await merchantInstance.post(
                    "/api/v1/merChant/financial/transfer-item/retry",
                    body,
                    { headers: { "X-App-Client": "weserve_backoffice" } }
                );
                const data = res && res.data ? res.data : res;
                const item = data && data.data && data.data.item ? data.data.item : data;
                if (item && item.id) commit("updateItemInList", item);
                return res;
            } catch (e) {
                commit("setError", e);
                return null;
            }
        },
    },
    getters: {
        list: (s) => s.list,
        loading: (s) => s.loading,
        error: (s) => s.error,
        count: (s) => s.count,
        page: (s) => s.page,
        page_size: (s) => s.page_size,
    },
};
